import { render, staticRenderFns } from "./prePayResult.vue?vue&type=template&id=98b495ce&scoped=true"
import script from "./prePayResult.vue?vue&type=script&lang=js"
export * from "./prePayResult.vue?vue&type=script&lang=js"
import style0 from "./prePayResult.vue?vue&type=style&index=0&id=98b495ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b495ce",
  null
  
)

export default component.exports